export default function () {
  let dropdowns = document.querySelectorAll('[data-dropdown-trigger]');

  if (!dropdowns) {
    return false;
  }

  for (let i = 0; i < dropdowns.length; i++) {
    dropdowns[i].addEventListener('click', function (e) {
      e.preventDefault();
      var dropdownTarget = this.getAttribute('data-dropdown-trigger');
      document.querySelector('[data-dropdown="' + dropdownTarget + '"]').classList.toggle('dropdown--visible');
    });
  }

  const targets = document.querySelectorAll('[data-dropdown-target]');

  if (!targets) {
    return false
  }

  for (let i = 0; i < targets.length; i++) {
    targets[i].addEventListener('click', function (e) {
      e.preventDefault();

      const key = this.getAttribute('data-dropdown-target')
      const data = this.getAttribute('data-value')
      const params = new URLSearchParams(window.location.search)

      if (!params.has(key)) {
        params.append(key, data)
      }

      if (params.has(key)) {
        params.set(key, data)
      }

      const url = window.location.origin + window.location.pathname + '?' + params.toString()

      window.location = url
    });
  }
}
